// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2864":"61eab7e2","3529":"61eab7e2","3936":"c52576dd","8122":"61eab7e2","8521":"61eab7e2","9653":"493b063e","9870":"61eab7e2"}[chunkId] + ".chunk.css";
};